var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_869_4034)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 22.0416H0V3.83325H3.16667V0.958252H6.33333V3.83325H12.6667V0.958252H15.8333V3.83325H19V22.0416ZM18.2083 7.66659H0.791667V21.0833H18.2083V7.66659ZM5.14504 16.0942L5.96204 15.9715C6.12117 16.8628 6.51067 17.4454 7.26354 17.4454C8.02117 17.4454 8.63392 16.788 8.63392 15.8795C8.63392 14.9317 7.96179 14.165 6.75529 14.5235L6.84633 13.7156C7.56675 13.8018 8.33467 13.3821 8.33467 12.4717C8.33467 11.8258 7.91667 11.2987 7.24533 11.2987C6.61913 11.2987 6.1655 11.7385 6.04358 12.6499L5.22658 12.486C5.43083 11.222 6.19796 10.5416 7.22713 10.5416C8.34417 10.5416 9.17383 11.3974 9.17383 12.4918C9.17383 13.1109 8.88646 13.6849 8.25708 14.0117C9.04321 14.2158 9.5 14.8876 9.5 15.8594C9.5 17.2585 8.47558 18.2083 7.25879 18.2083C6.04675 18.2083 5.25033 17.3026 5.14504 16.0942ZM12.6667 18.2083H11.8505V12.2043C11.4396 12.6461 10.7785 13.1118 10.2917 13.315V12.4247C11.3335 11.8727 11.9035 11.0811 12.141 10.5416H12.6667V18.2083ZM18.2083 4.79159H0.791667V6.70825H18.2083V4.79159ZM5.54167 1.91659H3.95833V3.83325H5.54167V1.91659ZM15.0417 1.91659H13.4583V3.83325H15.0417V1.91659Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_869_4034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calenderIcon.57d106cc504efd3343c7bcc261436232.svg";
export { ForwardRef as ReactComponent };